export const MAIN_MODULE_CONSTANT = {
  DETAIL_START: '/LI/main-module/detail/requested',
  DETAIL_FAILED: '/LI/main-module/detail/failed',
  DETAIL_SUCCESS: '/LI/main-module/detail/success',

  RESET_STATUS: 'LI/main-module/reset-status',
  RESET_ALL: 'LI/main-module/reset-all',
};
